import { Checkbox, Input, Select } from "antd";
import React from "react";
import Header from "../../common/Header";
import preve_arrow from "../../../images/prve-arrow.png";
import { useNavigate } from "react-router-dom";
import Loading from "../../common/Loading/loading";

const SocietyDetailsComponent = ({
  id,
  formValues,
  wingLabels,
  followPattern,
  validation,
  DefaultError,
  onInputChange,
  onTypeChange,
  onSelectChange,
  onFieldChange,
  onCheckboxChange,
  onAddSociety,
  loading,
  handelUpdateDetails,
  wingLength,
  updateLoader,
  wingFlor_length,
  isEditRoute,
  states,
  cities,
  onStateChange,
  onCityChange,
}) => {
  const navigate = useNavigate();

  const selectedStateCode = states.find(s => s.name === formValues.state)?.isoCode;

  return (
    <>
      <Header title="Dashboard" />
      <div className="header-title" onClick={() => navigate("/society-list")}>
        <img src={preve_arrow} alt="preve_arrow" className="preve_arrow" />
        <span>{id ? "Society List" : "Add Society"}</span>
      </div>
      <div className="admin-container">
        <div className="login-right-content">
          <div className="login-right">
            <div>
              <h2>Society Details</h2>
            </div>
            <div className="register-form">
              <div className="child-container">
                <p>Society Name</p>
                <Input
                  size="large"
                  className="input-field"
                  placeholder="Society Name"
                  name="name"
                  onChange={onInputChange}
                  value={formValues.name}
                />
                {validation.name && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.name}
                  </p>
                )}
              </div>
              <div className="child-container">
                <p>Type</p>
                <Select
                  placeholder="Select Society Type" 
                  optionFilterProp="label"
                  name="type"
                  value={formValues.type || undefined}
                  onChange={onTypeChange}
                  options={[
                    {
                      value: "residential",
                      label: "Residential",
                    },
                    {
                      value: "commercial",
                      label: "Commercial",
                    },
                  ]}
                  allowClear 
                />
                {validation.type && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.type}
                  </p>
                )}
              </div>

              <div className="child-container">
                <p>Location/Address :</p>
                <Input
                  className="input-field"
                  placeholder="Address"
                  name="address"
                  onChange={onInputChange}
                  value={formValues.address}
                />
                {validation.address && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.address}
                  </p>
                )}
              </div>
              <div className="child-container">
                <p>State</p>
                <Select
                  showSearch
                  placeholder="Select State"
                  optionFilterProp="label"
                  onChange={onStateChange}
                  value={selectedStateCode || undefined}
                  options={states.map((state) => ({
                    value: state.isoCode,
                    label: state.name,
                  }))}
                />
                {validation.state && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.state}
                  </p>
                )}
              </div>
              <div className="child-container">
                <p>City</p>
                <Select
                  showSearch
                  placeholder="Select City"
                  optionFilterProp="label"
                  onChange={onCityChange}
                  value={formValues.city || undefined}
                  // The city dropdown is disabled until a state is selected
                  disabled={!formValues.state}
                  options={cities.map((city) => ({
                    value: city.name,
                    label: city.name,
                  }))}
                />
                {validation.city && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.city}
                  </p>
                )}
              </div>
              <div className="child-container">
                <p>PIN Code</p>
                <Input
                  className="input-field"
                  placeholder="Enter PIN Code"
                  name="pin_code"
                  onChange={onInputChange}
                  value={formValues.pin_code}
                  maxLength={6}
                />
                {validation.pin_code && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.pin_code}
                  </p>
                )}
              </div>

              <div className="child-container">
                <p>Registration Number</p>
                <Input
                  className="input-field"
                  placeholder="Enter Registration Number"
                  name="registration_number"
                  onChange={onInputChange}
                  value={formValues.registration_number}
                />
                {validation.registration_number && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {validation.registration_number}
                  </p>
                )}
              </div>
            </div>
            <div className="select-wing-container">
              <div className="select-wing">
                <p>Select no. of Wing</p>
                <Select
                  showSearch
                  placeholder="Select Wing"
                  optionFilterProp="label"
                  onChange={onSelectChange}
                  value={
                    formValues?.wings.length ? formValues?.wings.length : 0
                  }
                  options={[
                    { value: "1", label: "1" },
                    { value: "2", label: "2" },
                    { value: "3", label: "3" },
                    { value: "4", label: "4" },
                    { value: "5", label: "5" },
                    { value: "6", label: "6" },
                    { value: "7", label: "7" },
                    { value: "8", label: "8" },
                    { value: "9", label: "9" },
                  ].filter((option) => {
                    if (isEditRoute) {
                      return parseInt(option.value, 10) >= wingLength;
                    }
                    return true;
                  })}
                />
                {DefaultError.wings && (
                  <p
                    style={{
                      color: "red",
                      paddingTop: "3px",
                      fontSize: "14px",
                    }}
                  >
                    {DefaultError.wings}
                  </p>
                )}
              </div>
              <div className="select-wing-label">
                {wingLabels.length > 0 ? <p>Wing Names or Labels</p> : ""}
                <div className="wing-label-main">
                  {wingLabels.map((label) => (
                    <div key={label}>{label}</div>
                  ))}
                </div>
              </div>
            </div>
            <div className="suggestion-desc">
              <p>Suggestion : </p>
              <span style={{ color: "#ffb302" }}>
                Flat Number Should Be Start From "101" or "1001".
              </span>
            </div>

            <div className="wing-details-container">
              {wingLabels.map((label, index) => {
                const currentWing =
                  wingFlor_length?.find((wing) => wing.name === label) || {};

                const currentNumberOfFloors = currentWing.total_floors || 0;
                const currentFlatsPerFloor = currentWing.flat_per_floor || 0;

                return (
                  <div className="wing-section-container" key={label}>
                    <p className="wing">WING “{label}”</p>
                    <div className="wing-section">
                      <div className="select-floors">
                        <p>Total Floors per Wing</p>
                        <Select
                          showSearch
                          placeholder="Select Total Floors"
                          optionFilterProp="label"
                          value={
                            formValues.wings.find((wing) => wing.name === label)
                              ?.numberOfFloors || ""
                          }
                          onChange={(value) =>
                            onFieldChange(label, "numberOfFloors", value)
                          }
                          options={[...Array(20).keys()]
                            .map((i) => ({ 
                              value: (i + 1).toString(),
                              label: (i + 1).toString(),
                            }))
                            .filter((option) => {
                              if (isEditRoute) {
                                return (
                                  parseInt(option.value, 10) >=
                                  currentNumberOfFloors
                                );
                              }
                              return true; 
                            })}
                        />
                        {validation[`wings[${index}].numberOfFloors`] && (
                          <span
                            className="error"
                            style={{
                              color: "red",
                              paddingTop: "3px",
                              fontSize: "14px",
                            }}
                          >
                            {validation[`wings[${index}].numberOfFloors`]}
                          </span>
                        )}
                      </div>
                      <div className="select-floors">
                        <p>Flats per Floor</p>
                        <Select
                          showSearch
                          placeholder="Select Flats per Floor"
                          optionFilterProp="label"
                          value={
                            formValues.wings.find((wing) => wing.name === label)
                              ?.flatsPerFloor || ""
                          }
                          onChange={(value) =>
                            onFieldChange(label, "flatsPerFloor", value)
                          }
                          options={[...Array(9).keys()]
                            .map((i) => ({
                              value: (i + 1).toString(),
                              label: (i + 1).toString(),
                            }))
                            .filter((option) => {
                              if (isEditRoute) {
                                return (
                                  parseInt(option.value, 10) >=
                                  currentFlatsPerFloor
                                );
                              }
                              return true;
                            })}
                        />
                        {validation[`wings[${index}].flatsPerFloor`] && (
                          <span
                            className="error"
                            style={{
                              color: "red",
                              paddingTop: "3px",
                              fontSize: "14px",
                            }}
                          >
                            {validation[`wings[${index}].flatsPerFloor`]}
                          </span>
                        )}
                      </div>
                      <div className="floore-number">
                        <p>Start Flat Number</p>
                        <Input
                          className="flat-input"
                          value={
                            formValues.wings.find((wing) => wing.name === label)
                              ?.startFlatNumber || ""
                          }
                          onChange={(e) =>
                            onFieldChange(
                              label,
                              "startFlatNumber",
                              e.target.value
                            )
                          }
                          disabled={
                            isEditRoute &&
                            !!wingFlor_length.find(
                              (wing) => wing.name === label
                            )?.flat_numbers[0]
                          }
                        />
                        {validation[`wings[${index}].startFlatNumber`] && (
                          <span
                            className="error"
                            style={{
                              color: "red",
                              paddingTop: "3px",
                              fontSize: "14px",
                            }}
                          >
                            {validation[`wings[${index}].startFlatNumber`]}
                          </span>
                        )}
                      </div>
                    </div>
                    {label === "A" && (
                      <Checkbox
                        className="follow-pattern"
                        checked={followPattern}
                        onChange={(e) => onCheckboxChange(e.target.checked)}
                      >
                        Follow pattern for all floors
                      </Checkbox>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="last-description">
              <div className="next-arrow-container">
                {!id ? (
                  <button className="add-society" onClick={onAddSociety}>
                    {loading ? (
                      <Loading type="spinner" color="#fff" />
                    ) : (
                      "Add Society"
                    )}
                  </button>
                ) : (
                  <button className="add-society" onClick={handelUpdateDetails}>
                    {updateLoader ? (
                      <Loading type="spinner" color="#fff" />
                    ) : (
                      "Save Details"
                    )}
                  </button>
                )}
              </div>
              <div className="description-text">
                <p>
                  {!id
                    ? "Create a new society by entering its details. This information helps organize and manage societies efficiently, ensuring that residents and administrators have easy access to essential information."
                    : "Modify the details for this society as needed. Ensuring accurate information allows for better organization, easier access, and effective society administration."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocietyDetailsComponent;
